import api from '../api'

const state = {
  poiList: []
}

const getters = {

}

const mutations = {
  setPOIs (state, poiList) {
    state.poiList = poiList
  }
}

const actions = {
  getPOIs ({ rootState, rootGetters, commit }, options) {
    return new Promise((resolve, reject) => {
      const position = rootGetters.getUserPosition
      if (position) {
        api.getClosestPOIs(
          rootState.college.id,
          position.lat,
          position.lon,
          options
        ).then((response) => {
          commit('setPOIs', response.data)
          resolve(response.data)
        })
      } else {
        api.getPOIs(rootState.college.id, options).then(response => {
          commit('setPOIs', response.data)
          resolve(response.data)
        })
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
